import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { Observable, of, Subject } from "rxjs";
import { takeUntil, debounceTime, startWith, map } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";
import { CustomerDashboardService } from "../../../services/customer-dashboard.service";
import * as moment from "moment";
import { MatSelectChange } from "@angular/material/select";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { FormControl } from "@angular/forms";

export enum TechnicianSteps {
  COMPANY,
  TECHNICIAN,
}

@Component({
  selector: "fury-claim-action-modal",
  templateUrl: "./claim-action-modal.component.html",
  styleUrls: ["./claim-action-modal.component.scss"],
})
export class ClaimActionModalComponent implements OnInit {
  ngUnsubscribe = new Subject<void>();
  public technicianSteps = TechnicianSteps;
  currentTechnicianStep = TechnicianSteps.COMPANY;
  selectedCompany = null;
  public technicianTabNames = {
    searchCompany: "Search Company",
    addNewCompany: "Add New Company",
    searchTechnician: "Search Technician",
    addNewTechnician: "Add New Technician",
  };
  private searchSubject = new Subject<string>();
  agents = [];
  allTechnicians = null;
  technicianTabName = "";
  @ViewChild("picker") picker: any;
  @ViewChild("fileOpen") fileOpen: ElementRef;
  commonAssignAction = [
    "assignClaimsConcierge",
    "assignCoordinator",
    "assignSupervisor",
    "assignPurchaser",
  ];
  commonInputActionField = ["addOutcome", "recall"];
  commonMaskedInputField = ["chargeCopay"];
  commonMaskedInputFieldWithNote = [
    "payTechnician",
    "addPayout",
    "payCustomer",
  ];
  commonInputTitle = {
    addOutcome: "Outcome",
    addPayout: "Payout",
    recall: "Recall",
    chargeCopay: "Charge Copay",
    payCustomer: "Pay Customer",
    payTechnician: "Pay Technician",
    orderReplacement: "Order Replacement",
    orderParts: "Order Parts",
    escalateClaim: "Escalate Claim",
  };

  modalHeading = {
    assignClaimsConcierge: "Assign Claims Concierge",
    assignCoordinator: "Assign Coordinator",
    assignSupervisor: "Assign Supervisor",
    assignOrEditTechnician: "Assign Technician",
    addOutcome: "Add Outcome",
    addPayout: "Add Payout",
    recall: "Recall",
    chargeCopay: "Charge Copay",
    payCustomer: "Pay Customer",
    payTechnician: "Pay Technician",
    addTechnicianSchedule: "Add Technician Schedule",
    orderReplacement: "Order Replacement",
    orderParts: "Order Parts",
    uploadDiagnosis: "Upload Diagnosis",
    escalateClaim: "Escalate Claim",
    updateClaimInfo: "Update Claim Info",
    cancelClaim: "Cancel Claim",
    assignCurrentUser: "Assign Current User",
    assignPurchaser: "Assign Purchaser",
  };
  modalButton = {
    assignClaimsConcierge: "Assign",
    assignCoordinator: "Assign",
    assignSupervisor: "Assign",
    assignOrEditTechnician: "Assign",
    addOutcome: "Add Outcome",
    addPayout: "Add Payout",
    recall: "Recall",
    chargeCopay: "Charge",
    payCustomer: "Pay Customer",
    payTechnician: "Pay Technician",
    addTechnicianSchedule: "Add Schedule",
    orderReplacement: "Place Replacement",
    orderParts: "Place Order",
    uploadDiagnosis: "Upload",
    escalateClaim: "Escalate Claim",
    updateClaimInfo: "Update",
    cancelClaim: "Submit",
    assignCurrentUser: "Assign",
    assignPurchaser: "Assign",
  };
  technicianScheduleValue = [
    "Mornings 7 to 11 AM",
    "Afternoons 12 to 3 PM",
    "Evenings 4 to 6 PM",
    "After Hours: 6 - 10 PM",
  ];
  fileName = "";
  diagnosisList: any[] = [];
  datePicker = {
    disabled: false,
    showSpinners: true,
    showSeconds: false,
    touchUi: false,
    enableMeridian: false,
    minDate: new Date().toISOString().split("T")[0],
    stepHour: 1,
    stepMinute: 1,
    stepSecond: 1,
    color: "primary",
  };
  technicianKeyWord = "";
  searchBy = "zipcode";
  radius = "100";
  searchUser: Observable<any[]> = of([]);
  serviceIds = new FormControl([]);
  columns = {
    columnsForZip: ["selectCompany", "companyName", "distance", "companyRating", "performanceScore", "phoneNo", "emailAddress", "trade"],
    columnsForState: ["selectCompany", "companyName", "companyRating", "performanceScore", "phoneNo", "emailAddress", "trade"],
  }
  displayedColumns = this.columns.columnsForZip;

  constructor(
    public dialogRef: MatDialogRef<ClaimActionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    public commonService: CommonService,
    private customerDashboardService: CustomerDashboardService
  ) {}

  ngOnInit(): void {
    this.technicianKeyWord = this.data?.zipCode;
    this.getData();
    this.searchSubject.pipe(debounceTime(300)).subscribe((searchValue) => {
      this.getTechnicians();
    });
    if (this.data?.actionModal === "addTechnicianSchedule") {
      this.data?.formGroup
        .get("value")
        ?.valueChanges.pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: any) => {
          if (res && moment().isAfter(res)) {
            this.data.formGroup.controls["value"].setErrors({
              notValid: true,
            });
          }
        });
    }
    if (this.data?.actionModal === "assignOrEditTechnician")
      this.searchTechnician();
  }
  searchTechnician() {
    setTimeout(() => {
      this.searchUser = this.data?.formGroup.get("userId")!.valueChanges.pipe(
        startWith(""),
        map((value) => (value ? this.filterUsers(value) : this.agents.slice()))
      );
    }, 100);
  }
  filterUsers(name: any) {
    let arr = this.agents.filter(
      (user: any) =>
        user?.fullName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
    return arr?.length ? arr : [{ fullName: "No item found", id: 0 }];
  }

  getData() {
    switch (this.data?.actionModal) {
      case "assignClaimsConcierge": {
        this.getAgents();
        this.getFileClaimInfo("assignClaimsConcierge");
        break;
      }
      case "assignCoordinator": {
        this.getAgents();
        this.getFileClaimInfo("assignCoordinator");
        break;
      }
      case "assignSupervisor": {
        this.getAgents();
        this.getFileClaimInfo("assignSupervisor");
        break;
      }
      case "assignOrEditTechnician": {
        this.data?.formGroup?.reset();
        this.getTechnicians();
        this.getServicesByClaimId();
        break;
      }
      case "addOutcome": {
        this.getFileClaimInfo("addOutcome");
        break;
      }
      case "addPayout": {
        this.getFileClaimInfo("addPayout");
        break;
      }
      case "recall": {
        this.getFileClaimInfo("recall");
        break;
      }
      case "chargeCopay": {
        this.getFileClaimInfo("chargeCopay");
        break;
      }
      case "payCustomer": {
        this.getFileClaimInfo("payCustomer");
        break;
      }
      case "payTechnician": {
        this.getFileClaimInfo("payTechnician");
        break;
      }
      case "orderReplacement": {
        this.data?.formGroup.reset();
        break;
      }
      case "orderParts": {
        this.getFileClaimInfo("orderParts");
        break;
      }
      case "addTechnicianSchedule": {
        this.getFileClaimInfo("addTechnicianSchedule");
        break;
      }
      case "escalateClaim": {
        this.getAgents();
        this.getFileClaimInfo("escalateClaim");
        break;
      }
      case "updateClaimInfo": {
        this.getFileClaimInfo("updateClaimInfo");
        break;
      }
      case "assignCurrentUser": {
        this.getAgents();
        this.getFileClaimInfo("assignCurrentUser");
        break;
      }
      case "assignPurchaser": {
        this.getAgents();
        this.getFileClaimInfo("assignPurchaser");
        break;
      }

      case "uploadDiagnosis": {
        this.data?.formGroup.reset();
        if (this.fileOpen?.nativeElement) {
          this.fileOpen.nativeElement.value = null;
        }

        break;
      }

      default: {
        break;
      }
    }
  }
  handleDateOpen() {
    this.picker.open();
    setTimeout(() => {
      this.picker.value = this.data?.formGroup?.value?.value;
    }, 1500);
  }

  getAgents() {
    this.customerDashboardService.getAgent$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((agents) => {
        if (agents?.length) {
          this.agents = agents;
        }
      });
  }

  getFileClaimInfo(actionTypes: string) {
    this.data?.formGroup?.reset();
    this.apiService
      .get(
        endpoints.customerDashboard.getFileClaimInfo(
          this.data?.fileClaimId,
          actionTypes
        )
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          if (!res?.body?.actionData) return;

          if (this.commonAssignAction.includes(this.data?.actionModal)) {
            this.data.formGroup
              .get("userId")
              .setValue(res?.body?.actionData?.userId);
            return;
          }

          if (this.data?.actionModal === "escalateClaim") {
            this.data.formGroup
              .get("value")
              .setValue(res?.body?.actionData?.userId);
            return;
          }
          if (this.commonInputActionField.includes(this.data?.actionModal)) {
            this.data.formGroup.get("value").setValue(res?.body?.actionData);
            this.data.formGroup
              .get("note")
              .setValue(res?.body?.actionData?.note);
            return;
          }
          if (this.data?.actionModal === "payCustomer") {
            this.data.formGroup
              .get("value")
              .setValue(res?.body?.actionData?.customer_payment);
            this.data.formGroup
              .get("note")
              ?.setValue(res?.body?.actionData?.customer_payment_note);
            return;
          }
          if (this.data?.actionModal === "updateClaimInfo") {
            this.data.formGroup?.patchValue(res?.body?.actionData);
            return;
          }
          if (this.data?.actionModal === "addTechnicianSchedule") {
            this.data.formGroup
              .get("technicianName")
              .setValue(
                `${res?.body?.actionData?.technicianDetail?.firstName} ${res?.body?.actionData?.technicianDetail?.lastName}`
              );
            this.data.formGroup
              .get("technicianId")
              .setValue(res?.body?.actionData?.technicianDetail?.userId);
            return;
          }

          if (this.data?.actionModal === "assignCurrentUser") {
            this.data.formGroup
              .get("value")
              .setValue(
                res?.body?.actionData?.map((item: any) => item?.userId)
              );
            return;
          }

          // if (this.data?.actionModal === "assignOrEditTechnician") {
          //   this.data.formGroup
          //     .get("userId")
          //     .setValue(res?.body?.actionData?.userId);
          //   return;
          // }

          this.data.formGroup.get("value")?.setValue(res?.body?.actionData);
        },
        (err: HttpErrorResponse) => {
          this.apiService.alert(err.error.message, ErrorType.Error);
        }
      );
  }

  close() {
    this.dialogRef.close();
  }
  get showButtonsSection() {
    return !(
      (this.currentTechnicianStep === this.technicianSteps.COMPANY &&
        this.technicianTabName === this.technicianTabNames.addNewCompany) ||
      (this.currentTechnicianStep === this.technicianSteps.TECHNICIAN &&
        this.technicianTabName === this.technicianTabNames.addNewTechnician)
    );
  }

  onTabChange(event: MatTabChangeEvent) {
    this.technicianTabName = event.tab?.textLabel;
    if (this.technicianTabName === this.technicianTabNames.searchTechnician) {
      this.fetchTechnicians();
    }
  }

  onSubmit(isOpenScheduleTechnicianModal = false) {
    if (this.data?.formGroup?.invalid) {
      this.data?.formGroup?.markAllAsTouched();
      return;
    }
    this.dialogRef.close({
      actionValue:
        this.data?.actionModal === "assignOrEditTechnician"
          ? {
              userId: this.data?.formGroup.controls["userId"]?.value,
              technicianId: this.data?.formGroup?.value?.technicianId,
              isOpenScheduleTechnicianModal
            }
          : this.data?.formGroup?.value,
    });
  }
  onFileUpload(event: any) {
    if (
      event.target.files[0].type === "image/jpeg" ||
      event.target.files[0].type === "image/png" ||
      event.target.files[0].type === "image/jpg" ||
      event.target.files[0].type === "application/pdf"
    ) {
      this.data?.formGroup?.get("value").setValue(event.target.files[0]);
      this.fileName = event.target.files[0]?.name;
    } else {
      this.apiService.alert(
        "Please select an image or pdf file",
        ErrorType.Error
      );
    }
  }
  downloadDiagnosis(url: string) {
    window.open(url, "_blank");
  }
  getTechnicians() {
    this.data.formGroup.get("userId").setValue("");
    this.apiService
      .get(
        `${endpoints.customerDashboard.getAgents}/1?searchBy=${this.searchBy}${
          this.technicianKeyWord ? "&keyword=" + this.technicianKeyWord : ""
        }${
          this.technicianKeyWord && this.radius ? "&radius=" + this.radius : ""
        }${
          this.serviceIds.value?.length
            ? "&serviceIds=" + this.serviceIds.value.toString()
            : ""
        }`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.agents = res.body?.agents;
          this.agents?.forEach((user) => {
            let trades = user?.trades?.map((trade) => trade?.title);
            user.tradesList = trades ? trades.toString().replace(/,/g, ', ') : "";
          });
          // Sorting the agents based on miles
         if(this.searchBy === 'zipcode'){
          this.agents.sort((a, b) => {
            if (a.miles === null) return 1;
            if (b.miles === null) return -1;
            return a.miles - b.miles;
          });
         }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error.message, ErrorType.Error);
          this.agents = [];
        },
      });
  }

  onNext() {
    if (!this.data?.formGroup.controls["userId"]?.value) {
      this.apiService.alert("Please choose a company", ErrorType.Error);
      return;
    }
    this.currentTechnicianStep = this.currentTechnicianStep + 1;
    this.fetchTechnicians();
  }

  fetchTechnicians() {
    if (this.currentTechnicianStep === this.technicianSteps.TECHNICIAN) {
      this.apiService
        .get(endpoints.customerDashboard.getTechnicians(this.data?.formGroup.controls["userId"]?.value))
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res: any) => {
            if (!res.body) return;
            this.allTechnicians = res.body.technicians || [];
            this.selectedCompany = res.body?.company;
          },
          (err: HttpErrorResponse) => {
            this.apiService.alert(err.error.message, ErrorType.Error);
          }
        );
    }
  }

  onBack() {
    this.currentTechnicianStep = this.currentTechnicianStep - 1;
  }
  handleSearchTechnician(e: MatSelectChange) {
    this.technicianKeyWord = null;
    if(e.value === 'zipcode') {
      this.displayedColumns = this.columns.columnsForZip;
    } else {
      this.displayedColumns = this.columns.columnsForState;
    }
    this.getTechnicians();
  }
  searchCompanyByKeyword() {
    this.searchSubject.next(this.technicianKeyWord);
    this.data.formGroup.get("userId").setValue("");
  }
  serviceSelectionChange(event) {
    this.searchSubject.next(this.technicianKeyWord);
  }
  getServicesByClaimId() {
    this.apiService
      .get(
        endpoints.settings.service.getServicesByClaimId(this.data?.fileClaimId)
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.serviceIds.patchValue(
              res.body?.services?.map((service) => service?.serviceId)
            );
            if (res.body?.services?.length > 0)
              this.searchSubject.next(this.technicianKeyWord);
          }
        },
      });
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
